export const platform = /(iPhone|iPod|BlackBerry|Android)/.test(navigator.userAgent) ? 'mobile' : 'web';

export const isMobile = (): boolean => platform === 'mobile';
